import { c as _c } from "react/compiler-runtime";
import { Badge, Button, Card, HStack, Icon, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { useOpportunityCounts } from '@src/components/sco/Advisors/hooks/useOpportunityCounts';
import { OpportunitiesAccessGate, OpportunitiesLayout } from '@src/components/sco/Advisors/layout/OpportunitiesLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { opportunitiesNavItems } from '@src/components/sco/Advisors/utils/opportunitiesNav';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { LuArrowRight } from 'react-icons/lu';
const OverviewBody = () => {
  const $ = _c(22);
  const paths = useAdvisorsPaths();
  const {
    counts
  } = useOpportunityCounts();
  let T0;
  let T1;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== counts || $[1] !== paths) {
    const sections = opportunitiesNavItems(paths).filter(_temp);
    T1 = VStack;
    t3 = "stretch";
    t4 = 5;
    T0 = SimpleGrid;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        base: 1,
        md: 2
      };
      $[9] = t0;
    } else {
      t0 = $[9];
    }
    t1 = 4;
    let t5;
    if ($[10] !== counts) {
      t5 = section => {
        const count = section.countKey ? counts[section.countKey] : 0;
        const SectionIcon = section.icon;
        return <Card.Root key={section.key} asChild={true} variant="interactive"><NextLink href={section.href}><Card.Body gap={3}><HStack gap={2} justify="space-between"><HStack color="colorPalette.fg/70" gap={2}><Icon boxSize={4}><SectionIcon /></Icon><Text fontWeight="semibold">{section.title}</Text></HStack><Badge colorPalette={count > 0 ? section.palette : "gray"} variant="subtle">{count}</Badge></HStack><Text color="colorPalette.fg/60" fontFamily="longform" fontSize="sm">{section.description}</Text><Button alignSelf="flex-start" pointerEvents="none" size="sm" variant="outline">Open <LuArrowRight /></Button></Card.Body></NextLink></Card.Root>;
      };
      $[10] = counts;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t2 = sections.map(t5);
    $[0] = counts;
    $[1] = paths;
    $[2] = T0;
    $[3] = T1;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[2];
    T1 = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[12] !== T0 || $[13] !== t0 || $[14] !== t1 || $[15] !== t2) {
    t5 = <T0 columns={t0} gap={t1}>{t2}</T0>;
    $[12] = T0;
    $[13] = t0;
    $[14] = t1;
    $[15] = t2;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== T1 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = <T1 align={t3} gap={t4}>{t5}</T1>;
    $[17] = T1;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};

/** `/advisors/opportunities` — readiness checklist plus a jump into each section. */
export const OpportunitiesOverviewSection = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <OpportunitiesAccessGate><OpportunitiesLayout activeKey="overview" title="Overview" description="Work through invites, applications, and matched seats. Setup lives under My Advisor Profile."><OverviewBody /></OpportunitiesLayout></OpportunitiesAccessGate>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(item) {
  return item.key !== "overview";
}